import { render, staticRenderFns } from "./imgBackground.vue?vue&type=template&id=166d881c&scoped=true&"
import script from "./imgBackground.vue?vue&type=script&lang=js&"
export * from "./imgBackground.vue?vue&type=script&lang=js&"
import style0 from "./imgBackground.vue?vue&type=style&index=0&id=166d881c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d881c",
  null
  
)

export default component.exports